import React from 'react';
import { RouterLinkProps } from './RouterLink.types';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import { Link, SvgIcon } from '@material-ui/core';
import { Link as ReactRouterLink } from 'react-router-dom';

const useStyles = makeStyles(() =>
	createStyles({
		textLink: {
			display: 'inline-flex',
			alignItems: 'center',
			lineHeight: 1,
		},
	}),
);

export const RouterLink: React.FC<RouterLinkProps> = ({
	children,
	prefixIcon,
	className,
	...rest
}) => {
	const classes = useStyles();

	return (
		<Link
			translate="yes"
			component={ReactRouterLink}
			className={classNames(className, classes.textLink)}
			{...rest}
		>
			{prefixIcon && <SvgIcon component={prefixIcon} fontSize="small" />}
			{children}
		</Link>
	);
};
